import { Button, Modal, TextContainer, TextField } from "@shopify/polaris"
import { Observer } from "mobx-react"
import React, { useCallback, useEffect, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useIntercom } from "react-use-intercom"

import app from "@/api/app"
import stores from "@/stores"
import toast from "@/utils/toast"
import { isValidEmail } from "@/utils/verify"

import { FeedbackModalProps } from "./FeedbackModal.d"

export default function FeedbackModal ({ onClose, show, rate = 0 }: FeedbackModalProps) {
  const { t } = useTranslation("common")

  const intercom = useIntercom()
  const [email, setEmail] = useState<string>("")
  const [emailErr, setEmailErr] = useState<string>("")
  const emailHandleChange = (newValue: string) => {
    setEmailErr("")
    setEmail(newValue)
  }

  const [msg, setMsg] = useState<string>("")
  const [msgErr, setMsgErr] = useState<string>("")
  const msgHandleChange = (newValue: string) => {
    setMsg(newValue)
    setMsgErr("")
  }

  useEffect(() => {
    if (show) {
      setMsgErr("")
      setEmailErr("")
      if (msg === "") {
        document.getElementById("FeedbackModalTellUs")
          ?.focus()
      } else if (email === "") {
        document.getElementById("FeedbackModalEmail")
          ?.focus()
      }
    }
  }, [show])

  const [emailFlag, setEmailFlag] = useState<boolean>(false)
  const emailFlagHandleChange = useCallback((active: boolean | ((prevState: boolean) => boolean)) => setEmailFlag(active), [emailFlag])

  // modal 主按钮是否在加载中
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const toggleBtnLoading = useCallback(setBtnLoading, [])

  const { userInfoSore } = stores

  useEffect(() => {
    if ((!isValidEmail(email) || !email) && !show && userInfoSore.data.user_email) {
      setEmail(userInfoSore.data.user_email)
      setEmailErr("")
    }
  }, [email, show, userInfoSore.data.user_email])

  return (
    <>
      <Observer>{() =>
        <Modal
          open={show}
          onClose={() => {
            onClose && onClose()
            setMsgErr("")
            setEmailErr("")
          }}
          title={t("FeedbackModal.title")}
          primaryAction={{
            content: t("Submit"),
            loading: btnLoading,
            disabled: msg === "" || email === "",
            onAction: () => {
              setMsgErr(msg ? "" : t("inputErrorBlank"))
              if (email) {
                setEmailErr(isValidEmail(email) ? "" : t("InvalidEmail", { ns: "email_edit" }))
              } else {
                setEmailErr(t("inputErrorBlank"))
              }

              if (!msg || !email || !isValidEmail(email)) {
                return
              }

              toggleBtnLoading(true)
              app.sendFeedback(!email ? userInfoSore.data.user_email : email, msg, "index-back", rate)
                .then(({ status }) => {
                  if (status === 200 || status === 201) {
                    toast(t("SubmitSuccessfully"))
                    msgHandleChange("")
                    onClose && onClose()
                  } else {
                    toast(t("SubmitFailed"), 2e3, true)
                  }
                })
                .finally(() => toggleBtnLoading(false))
            },
          }}
          secondaryActions={[
            {
              content: t("Cancel"),
              onAction: () => {
                onClose && onClose()
                setMsgErr("")
                setEmailErr("")
              },
            },
          ]}
        >
          <Modal.Section>
            <TextContainer>
              <TextField
                id={"FeedbackModalTellUs"}
                label={t("FeedbackModal.TellUs")}
                value={msg}
                placeholder={t("FeedbackModal.EditMsg")}
                onChange={msgHandleChange}
                maxHeight={"10.6rem"}
                multiline={4}
                autoComplete="off"
              />

              {/* 当不存在值时，使用外面传来的邮箱 */}
              {!emailFlag && <TextField
                id="FeedbackModalEmail"
                type="email"
                error={emailErr}
                label={t("FeedbackModal.YourEmail")} value={userInfoSore.data.user_email}
                autoComplete="off"
                onChange={v => {
                  emailHandleChange(v)
                  emailFlagHandleChange(true)
                  setEmailErr("")
                }}
              />}

              {/* 只要一存在，马上切换为真是输入框 */}
              {emailFlag && <TextField
                id="FeedbackModalEmail"
                type="email"
                label={t("FeedbackModal.YourEmail")} value={email}
                error={emailErr}
                placeholder="e.g. parcelpanel100@gmail.com"
                autoComplete="off" focused onChange={emailHandleChange}
                onBlur={() => {
                  if (email && !isValidEmail(email)) {
                    setEmailErr(t("InvalidEmail", { ns: "email_edit" }))
                  }
                }}
              />}
            </TextContainer>

            <div className={"mt-3"}>
              <Trans ns={"common"} i18nKey={"ReviewGuideFooter"}>
                <Button variant={"plain"} onClick={() => {
                  intercom.showMessages()
                  onClose && onClose()
                }}
                />
              </Trans>
            </div>
          </Modal.Section>
        </Modal>
      }</Observer>
    </>
  )
}
